"use strict";

/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var connection_1 = require("../connection");
var pool_1 = __importStar(require("../pool"));
var neo4j_driver_core_1 = require("neo4j-driver-core");
var SERVICE_UNAVAILABLE = neo4j_driver_core_1.error.SERVICE_UNAVAILABLE;
var PooledConnectionProvider = /** @class */function (_super) {
  __extends(PooledConnectionProvider, _super);
  function PooledConnectionProvider(_a, createChannelConnectionHook) {
    var id = _a.id,
      config = _a.config,
      log = _a.log,
      userAgent = _a.userAgent,
      authToken = _a.authToken;
    if (createChannelConnectionHook === void 0) {
      createChannelConnectionHook = null;
    }
    var _this = _super.call(this) || this;
    _this._id = id;
    _this._config = config;
    _this._log = log;
    _this._userAgent = userAgent;
    _this._authToken = authToken;
    _this._createChannelConnection = createChannelConnectionHook || function (address) {
      return (0, connection_1.createChannelConnection)(address, _this._config, _this._createConnectionErrorHandler(), _this._log);
    };
    _this._connectionPool = new pool_1.default({
      create: _this._createConnection.bind(_this),
      destroy: _this._destroyConnection.bind(_this),
      validate: _this._validateConnection.bind(_this),
      installIdleObserver: PooledConnectionProvider._installIdleObserverOnConnection.bind(_this),
      removeIdleObserver: PooledConnectionProvider._removeIdleObserverOnConnection.bind(_this),
      config: pool_1.PoolConfig.fromDriverConfig(config),
      log: _this._log
    });
    _this._openConnections = {};
    return _this;
  }
  PooledConnectionProvider.prototype._createConnectionErrorHandler = function () {
    return new connection_1.ConnectionErrorHandler(SERVICE_UNAVAILABLE);
  };
  /**
   * Create a new connection and initialize it.
   * @return {Promise<Connection>} promise resolved with a new connection or rejected when failed to connect.
   * @access private
   */
  PooledConnectionProvider.prototype._createConnection = function (address, release) {
    var _this = this;
    return this._createChannelConnection(address).then(function (connection) {
      connection._release = function () {
        return release(address, connection);
      };
      _this._openConnections[connection.id] = connection;
      return connection.connect(_this._userAgent, _this._authToken).catch(function (error) {
        // let's destroy this connection
        _this._destroyConnection(connection);
        // propagate the error because connection failed to connect / initialize
        throw error;
      });
    });
  };
  /**
   * Check that a connection is usable
   * @return {boolean} true if the connection is open
   * @access private
   **/
  PooledConnectionProvider.prototype._validateConnection = function (conn) {
    if (!conn.isOpen()) {
      return false;
    }
    var maxConnectionLifetime = this._config.maxConnectionLifetime;
    var lifetime = Date.now() - conn.creationTimestamp;
    return lifetime <= maxConnectionLifetime;
  };
  /**
   * Dispose of a connection.
   * @return {Connection} the connection to dispose.
   * @access private
   */
  PooledConnectionProvider.prototype._destroyConnection = function (conn) {
    delete this._openConnections[conn.id];
    return conn.close();
  };
  PooledConnectionProvider.prototype.close = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // purge all idle connections in the connection pool
            return [4 /*yield*/, this._connectionPool.close()
            // then close all connections driver has ever created
            // it is needed to close connections that are active right now and are acquired from the pool
            ];

          case 1:
            // purge all idle connections in the connection pool
            _a.sent();
            // then close all connections driver has ever created
            // it is needed to close connections that are active right now and are acquired from the pool
            return [4 /*yield*/, Promise.all(Object.values(this._openConnections).map(function (c) {
              return c.close();
            }))];
          case 2:
            // then close all connections driver has ever created
            // it is needed to close connections that are active right now and are acquired from the pool
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };

  PooledConnectionProvider._installIdleObserverOnConnection = function (conn, observer) {
    conn._queueObserver(observer);
  };
  PooledConnectionProvider._removeIdleObserverOnConnection = function (conn) {
    conn._updateCurrentObserver();
  };
  return PooledConnectionProvider;
}(neo4j_driver_core_1.ConnectionProvider);
exports.default = PooledConnectionProvider;